/**
 * <variant-selects> — pill/select variant picker. On change, re-fetches the
 * whole `main-product` section for the newly selected variant (Section
 * Rendering API, `?variant=ID&section_id=main-product`) and swaps both the
 * media gallery and buy box back in. This keeps price, compare-at price,
 * availability, media, and the add-to-cart state correct without
 * duplicating Shopify's money/availability formatting logic in JS — the
 * server renders it once, same as the initial page load.
 */
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.variants = JSON.parse(this.querySelector('[data-variant-json]').textContent);
  }

  connectedCallback() {
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  getSelectedOptions() {
    const options = [];
    this.querySelectorAll('[data-option-position]').forEach((input) => {
      if (input.type === 'radio' && !input.checked) return;
      options[parseInt(input.dataset.optionPosition, 10) - 1] = input.value;
    });
    return options;
  }

  findVariant(options) {
    return this.variants.find((variant) =>
      variant.options.every((value, index) => value === options[index])
    );
  }

  onVariantChange() {
    const options = this.getSelectedOptions();
    const variant = this.findVariant(options);
    if (!variant) return;

    this.querySelectorAll('[data-selected-value]').forEach((el, index) => {
      el.textContent = ': ' + options[index];
    });

    this.updateSection(variant);
  }

  async updateSection(variant) {
    const productUrl = this.dataset.productUrl;
    const section = this.closest('[data-product-info]');
    if (!section) return;
    section.classList.add('is-loading');

    try {
      const response = await fetch(`${productUrl}?variant=${variant.id}&section_id=main-product`);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newBuyBox = doc.querySelector('[data-product-info]');
      const newMedia = doc.querySelector('.product-page__media');
      const currentMedia = document.querySelector('.product-page__media');

      if (newMedia && currentMedia) currentMedia.replaceWith(newMedia);
      if (newBuyBox) section.replaceWith(newBuyBox);

      history.replaceState({}, '', `${productUrl}?variant=${variant.id}`);
      window.NantesPubSub.publish(window.NantesEvents.variantChange, variant);
    } catch (error) {
      section.classList.remove('is-loading');
    }
  }
}

customElements.define('variant-selects', VariantSelects);
